import { JSX, ReactNode, createContext, useContext, useState } from 'react';

export type LockedFeature = {
  isLocked: boolean;
  updateIsLocked: (b: boolean, f: string) => void;
  lockedFeature: string;
};

export const LockedFeatureDialogueContext = createContext<LockedFeature>({
  isLocked: false,
  updateIsLocked: () => {},
  lockedFeature: '',
});

export const LockedFeatureDialogue = ({ children }: { children: ReactNode }): JSX.Element => {
  const [isLocked, setIsLocked] = useState(false);
  const [lockedFeature, setLockedFeature] = useState('');

  const updateIsLocked = (b: boolean, f: string) => {
    if (b) {
      setLockedFeature(f);
    }
    setIsLocked(b);
  };

  return (
    <LockedFeatureDialogueContext.Provider
      value={{
        lockedFeature,
        isLocked,
        updateIsLocked,
      }}
    >
      {children}
    </LockedFeatureDialogueContext.Provider>
  );
};

export const useLockedFeatureDialogue = (): LockedFeature => useContext(LockedFeatureDialogueContext);
